import React, { useState } from 'react';
//Material-UI
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
//Icon
import DoneIcon from '@material-ui/icons/Done';
//Context
import { useLlamadas } from './LlamadasContext';
//Styles
import '../../styles/llamadas.css';

export default function General() {
    const {
        areasAtencion,
        GreenChip,
        YellowChip,
        RedChip,
        BlueChip,
        selectedArea,
        setSelectedArea,
        setSelectedColor,
        handleInputChange,
    } = useLlamadas();
    const [green, setGreen] = useState(<DoneIcon />);
    const [red, setRed] = useState(<p />);
    const [blue, setBlue] = useState(<p />);
    const [yellow, setYellow] = useState(<p />);

    const handleAreaChange = (event) => {
        event.preventDefault();
        handleInputChange(event);
        setSelectedArea(event.target.value);
    };
    const handleColorChange = (e, id) => {
        e.preventDefault();
        setSelectedColor(id);
        switch (id) {
            case 1:
                setGreen(<DoneIcon />);
                setRed(<p />);
                setBlue(<p />);
                setYellow(<p />);
                break;
            case 2:
                setGreen(<p />);
                setRed(<DoneIcon />);
                setBlue(<p />);
                setYellow(<p />);
                break;
            case 3:
                setGreen(<p />);
                setRed(<p />);
                setBlue(<DoneIcon />);
                setYellow(<p />);
                break;
            case 4:
                setGreen(<p />);
                setRed(<p />);
                setBlue(<p />);
                setYellow(<DoneIcon />);
                break;
            default:
                setGreen(<p />);
                setRed(<p />);
                setBlue(<p />);
                setYellow(<p />);
                break;
        }
    };

    return (
        <div>
            <div className="llamada-step-field">
                <TextField
                    name="nombre"
                    label="NOMBRE"
                    fullWidth
                    onChange={(e) => handleInputChange(e)}
                />
            </div>
            <div className="llamada-step-field">
                <InputLabel shrink id="lblArea" fullWidth>
                    AREA DE ATENCIÓN
                </InputLabel>
                <Select
                    labelId="lblArea"
                    name="areaAtencion"
                    onChange={handleAreaChange}
                    displayEmpty
                    value={selectedArea}
                    fullWidth
                >
                    {areasAtencion.map((item) => (
                        <MenuItem key={item.codigo.toString()} value={item.codigo.toString()}>
                            {item.nombre.toString()}
                        </MenuItem>
                    ))}
                </Select>
            </div>
            <div>
                <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend" className="llamada-step-color-label">
                        SELECCIONAR COLOR
                    </FormLabel>
                    <div className="llamada-step-chips">
                        <Grid container spacing={1}>
                            <Grid item sm={3}>
                                <GreenChip
                                    label="VERDE"
                                    color="primary"
                                    clickable
                                    onClick={(e) => handleColorChange(e, 1)}
                                    onDelete={(e) => handleColorChange(e, 1)}
                                    deleteIcon={green}
                                />
                            </Grid>
                            <Grid item sm={3}>
                                <RedChip
                                    label="ROJO"
                                    color="primary"
                                    clickable
                                    onClick={(e) => handleColorChange(e, 2)}
                                    onDelete={(e) => handleColorChange(e, 2)}
                                    deleteIcon={red}
                                />
                            </Grid>
                            <Grid item sm={3}>
                                <BlueChip
                                    label="AZUL"
                                    color="primary"
                                    clickable
                                    onClick={(e) => handleColorChange(e, 3)}
                                    onDelete={(e) => handleColorChange(e, 3)}
                                    deleteIcon={blue}
                                />
                            </Grid>
                            <Grid item sm={3}>
                                <YellowChip
                                    label="AMARILLO"
                                    color="primary"
                                    clickable
                                    onClick={(e) => handleColorChange(e, 4)}
                                    onDelete={(e) => handleColorChange(e, 4)}
                                    deleteIcon={yellow}
                                />
                            </Grid>
                        </Grid>
                    </div>
                </FormControl>
            </div>
        </div>
    );
}
